module.exports = __webpack_public_path__ + "static/media/krem_hero-dark.ee38d417.png";